var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 6.66669V13.3334H12C13.1046 13.3334 14 12.4379 14 11.3334V8.66669C14 7.56212 13.1046 6.66669 12 6.66669H7.33333ZM10 8.00002H8.66667V12H12C12.3682 12 12.6667 11.7015 12.6667 11.3334V8.66669C12.6667 8.2985 12.3682 8.00002 12 8.00002H11.3333V8.66669C11.3333 9.03488 11.0349 9.33335 10.6667 9.33335C10.2985 9.33335 10 9.03488 10 8.66669V8.00002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.66669C2.89543 6.66669 2 7.56212 2 8.66669V11.3334C2 12.4379 2.89543 13.3334 4 13.3334H8.66667V6.66669H4ZM4.66667 8.00002H4C3.63181 8.00002 3.33333 8.2985 3.33333 8.66669V11.3334C3.33333 11.7015 3.63181 12 4 12H7.33333V8.00002H6V8.66669C6 9.03488 5.70152 9.33335 5.33333 9.33335C4.96514 9.33335 4.66667 9.03488 4.66667 8.66669V8.00002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 1.33331C5.5621 1.33331 4.66667 2.22874 4.66667 3.33331V7.99998H11.3333V3.33331C11.3333 2.22874 10.4379 1.33331 9.33333 1.33331H6.66667ZM7.33333 2.66665H6.66667C6.29848 2.66665 6 2.96512 6 3.33331V6.66665H10V3.33331C10 2.96512 9.70152 2.66665 9.33333 2.66665H8.66667V3.33331C8.66667 3.7015 8.36819 3.99998 8 3.99998C7.63181 3.99998 7.33333 3.7015 7.33333 3.33331V2.66665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.2e837526.svg";
export { ForwardRef as ReactComponent };